import {
    HOME_COLUMN,
    DRAW_COLUMN,
    AWAY_COLUMN,
    THREE_WAY_COLUMN_LENGTH,
} from '../../../shared/components/selection/constants';


/**
 * Orders the sport market headers
 * @param  {Object} marketHeaders   the market header objects
 * @param  {Number} numberOfColumns the number of columns
 * @return {Array}  the ordered column names
 */
export function orderSportMarketHeaders(marketHeaders, numberOfColumns) {
    const homeColumn = marketHeaders[HOME_COLUMN];
    const drawColumn = marketHeaders.hasOwnProperty(DRAW_COLUMN) ? marketHeaders[DRAW_COLUMN] : '';
    const awayColumn = marketHeaders[AWAY_COLUMN];

    return numberOfColumns === THREE_WAY_COLUMN_LENGTH ? [homeColumn, drawColumn, awayColumn] : [homeColumn, awayColumn];
}
